import React from "react";

import { web } from "@kikoff/proto/src/protos";

import { UnderlineButton } from "@component/buttons/buttons";
import { useAutoRenewInfo } from "@feature/shopping";
import { useOverlaysController } from "@src/overlay";
import { track } from "@util/analytics";

import styles from "./subscriptions_autorenewal_button.module.scss";

interface SubscriptionAutoRenewButtonProps {
  subscription: web.public_.IUserSubscription;
}

export default function SubscriptionAutoRenewButton({
  subscription,
}: SubscriptionAutoRenewButtonProps) {
  const overlays = useOverlaysController();

  const { autoRenewEnabled, autoRenewDate } = useAutoRenewInfo(subscription);

  const subscriptionAvailable =
    subscription.status === web.public_.UserSubscription.Status.ACTIVE;

  if (!subscriptionAvailable) return null;

  return (
    <UnderlineButton
      className={styles["autorenew-button"]}
      onClick={() => {
        const { status } = subscription.autoRenew;

        track.impression("CA - Subscription - Toggle Autorenew Overlay", {
          status,
        });

        overlays.push("shopping/toggle_autorenew", {
          autoRenewDate,
          status,
          title: subscription.title,
          token: subscription.token,
        });
      }}
    >
      <div className={styles["autorenew-text"]}>
        {autoRenewEnabled ? "Cancel auto-renew" : "Turn on auto-renew"}
      </div>
    </UnderlineButton>
  );
}
